"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JSONNonVisualPropertiesConverter = void 0;
var non_visual_drawing_object_info_1 = require("../../../manipulators/picture-manipulator/non-visual-drawing-object-info");
var json_floating_enums_1 = require("../../enums/json-floating-enums");
var JSONNonVisualPropertiesConverter = (function () {
    function JSONNonVisualPropertiesConverter() {
    }
    JSONNonVisualPropertiesConverter.convertFromJSON = function (obj) {
        var result = new non_visual_drawing_object_info_1.NonVisualDrawingObjectInfo();
        if (obj) {
            result.id = obj[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Id];
            result.name = obj[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Name];
            result.title = obj[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Title];
            result.description = obj[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Description];
        }
        return result;
    };
    JSONNonVisualPropertiesConverter.convertToJSON = function (source) {
        var result = {};
        result[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Id] = source.id;
        result[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Name] = source.name;
        result[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Title] = source.title;
        result[json_floating_enums_1.JSONNonVisualDrawingObjectProperties.Description] = source.description;
        return result;
    };
    return JSONNonVisualPropertiesConverter;
}());
exports.JSONNonVisualPropertiesConverter = JSONNonVisualPropertiesConverter;
